import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Students = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/home", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-orange-50">
      <div className="bg-white/80 backdrop-blur rounded-2xl shadow-lg p-10 text-center max-w-md">
        <div className="text-5xl mb-4">🔍</div>
        <h1 className="text-2xl font-semibold text-gray-800 mb-2">Student search moved!</h1>
        <p className="text-gray-600">
          You can now explore classmates directly from the Home page. We&apos;re taking you there now...
        </p>
      </div>
    </div>
  );
};

export default Students;
